<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Laporan Transaksi</li>
              </ol>
            </div>
            <h4 class="page-title">Laporan Transaksi</h4>
          </div>
        </div>
      </div>

    <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
            <div class="wrapper-table-default">
                <div class="row mb-3">
                    <div class="col-12 col-md-6">
                        <label for="">Nama OPD</label>
                        <select name="" id="" class="form-control" v-model="filter.organization" @change="onSelected(filter.organization)">
                            <option :value="null">Semua OPD</option>
                            <option :value="item.id" v-for="item in allOrganization" :key="item.id">{{item.name}}</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6">
                        <label for="">Nama Objek Retribusi</label>
                        <select name="" id="" class="form-control" v-model="filter.company">
                            <option :value="null">Semua Objek Retribusi</option>
                            <option :value="item.id" v-for="item in allCompany" :key="item.id">{{item.name}}</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4">
                        <label for="" style="margin-top: 10px;">Tanggal Penetapan</label>
                        <date-picker required style="width: 100%" v-model="filter.date" :placeholder="'Dari - Sampai'" format="DD/MM/YYYY" range></date-picker>
                    </div>
                    <div class="col-12 col-md-4">
                        <label for="" style="margin-top: 10px;">Tanggal Transaksi</label>
                        <date-picker required style="width: 100%" v-model="filter.pay_date" :placeholder="'Dari - Sampai'" format="DD/MM/YYYY" range></date-picker>
                    </div>
                    <div class="col-12 col-md-3">
                        <button class="btn btn-primary" @click="loadData" style="margin-top: 33px;">Filter</button>
                        <div class="btn-group ml-2" style="margin-top: 33px;">
                            <button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Export Data
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click.prevent="exportData('pdf')">PDF</a>
                                <a class="dropdown-item" @click.prevent="exportData('excel')">EXCEL</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Invoice Code</th>
                                <th class="text-center">Objek Retribusi</th>
                                <th class="text-center">Tanggal Penetapan</th>
                                <th class="text-center">Tanggal Transaksi</th>
                                <th class="text-center">Kategori Retribusi</th>
                                <th class="text-center">Status</th>
                                <th class="text-right">Total</th>
                                <th>Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in dataTransaction" :key="item.id">
                                <td >{{ item.invoice_code }}</td>
                                <td class="text-center">{{ item.company.name }}</td>
                                <th class="text-center" valign="center">
                                    {{ item.invoice_date ? convertDate(item.invoice_date) : '-' }}
                                </th>
                                <th class="text-center" valign="center">
                                    {{ item.pay_date ? convertDate(item.pay_date) : '-' }}
                                </th>
                                <!-- <td class="text-center"></td> -->
                                <td class="text-center">
                                    <span v-for="(service, index) in item.service_name" :key="service+index">
                                        {{service}}
                                        <template v-if="index != item.service_name.length - 1">, </template>
                                    </span>
                                </td>
                                
                                <td class="text-right">
                                    <GetStatusInTable :data="item"></GetStatusInTable>
                                </td>
                                
                                <td class="text-right">{{ currency(item.total) }}</td>
                                <td>
                                     <button class="btn btn-primary waves-effect waves-light ml-2" 
                                        @click.prevent="loadDetail(item.id)">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                    <!-- <button class="btn btn-warning waves-effect waves-light ml-2" 
                                        :disabled="loadingDownloadPDF"
                                        @click.prevent="getPDF(item.id, item.invoice_code)">
                                        
                                        <div class="spinner-border text-light" role="status" v-if="loadingDownloadPDF">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        
                                        <i class="fas fa-print" v-else></i>
                                        
                                    </button> -->
                                    <!-- <button class="btn btn-danger waves-effect waves-light ml-2" @click.prevent="deleteItem(item.id, item.invoice_code)">
                                        <i class="fas fa-trash"></i>
                                    </button> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="clearfix mt-3">
                    <div class="float-right">
                        <paginate 
                            v-model="paging.currentPage"
                            :page-count="paging.rows" :page-range="3" :margin-pages="2" :click-handler="paginate"
                            :prev-text="'Prev'" :next-text="'Next'" :prev-class="'page-link'" :next-class="'page-link'"
                            :container-class="'pagination mb-0'" :page-link-class="'page-link'" :page-class="'page-item'" align="right">
                        </paginate>
                    </div>
                </div>
            </div>
          </div>
      </div>
      
      <div class="modal fade" id="modalDetail" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mt-0" id="mySmallModalLabel">
                        <span v-if="loadingDetail">Loading ...</span>
                        <span v-else>#{{dataDetail.invoice_code}}</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="card card-loader d-flex" v-if="loadingDetail" style="height: 50vh; background-color: transparent">
                        <div class="justify-content-center">
                            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p class="mt-2">Loading</p>
                        </div>
                    </div>

                    <div v-else>
                        <div class="row align-items-center" style="margin-bottom: 20px">
                            <div class="col-12 col-md-9">
                                <div class="d-flex align-items-center">
                                    <!-- <img :src="$store.state.userData.company_logo" style="height: 50px" class="mr-5"> -->
                                    <table>
                                        <tr>
                                            <td><b>Invoice Code</b></td>
                                            <td>: #{{ dataDetail.invoice_code }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Tanggal Transaksi</b></td>
                                            <td>: {{ dataDetail.pay_date ? dataDetail.pay_date : '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Metode Pembayaran</b></td>
                                            <td>: {{ dataDetail.payment_method ? paymentMethodName(dataDetail.payment_method) : '-' }}</td>
                                        </tr>
                                        <tr v-if="dataDetail.is_penalty">
                                            <td><b>Periode Denda</b></td>
                                            <td>: {{ dataDetail.penalty_period_value }} {{ convertPeriod(dataDetail.penalty_period) }}</td>
                                        </tr>
                                        <tr v-if="dataDetail.is_penalty">
                                            <td><b>Jumlah Denda</b></td>
                                            <td>: {{ dataDetail.penalty_nominal_type == 'PERCENTAGE' ? dataDetail.penalty_nominal_value : currency(dataDetail.penalty_nominal_value) }} {{ dataDetail.penalty_nominal_type == 'PERCENTAGE' ? '%' : '' }}</td>
                                        </tr>
                                        <tr v-if="dataDetail.va_no">
                                            <td><b>No ID</b></td>
                                            <td>: {{ dataDetail.va_no }}</td>
                                        </tr>
                                        <tr v-if="dataDetail.status">
                                            <td><b>Status</b></td>
                                            <!-- <td>: {{ dataDetail.status }}</td> -->
                                            <td v-if="dataDetail.status == 'SUCCESS'"><span class="badge badge-success">SUKSES</span></td>
                                            <td v-else-if="dataDetail.status == 'PENDING'"><span class="badge badge-warning">PENDING</span></td>
                                            <td v-else-if="dataDetail.status == 'WAITING_PROCESS'"><span class="badge badge-primary">MENUNGGU PERSETUJUAN</span></td>
                                            <td v-else-if="dataDetail.status == 'WAITING_CONFIRMATION'"><span class="badge badge-primary">DRAFT</span></td>
                                            <td v-else><span class="badge badge-danger">EXPIRED</span></td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-12 col-md-3">
                                <div class="text-center">
                                    <button type="button" class="btn btn-primary" @click.prevent="refreshTransaction">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th>Kategori Retribusi</th>
                                                <th class="text-right">Harga</th>
                                                <th class="text-right">Jumlah</th>
                                                <th class="text-right">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in dataDetail.objectRetribution" :key="item.id">
                                                <th>{{item.service_name}}</th>
                                                <td class="text-right">{{currency(item.price)}}</td>
                                                <td class="text-right">{{item.qty}}</td>
                                                <td class="text-right">{{currency(item.total)}}</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2" class="border-0"></th>
                                                <td class="border-0 font-14"><b>Total</b></td>
                                                <td class="bg-dark text-white border-0 font-14 text-right"><b>{{currency(dataDetail.total)}}</b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row d-flex justify-content-center">
                        <a href="#" class="btn btn-primary" data-dismiss="modal">Tutup</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment"
import fileDownload from 'js-file-download'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    data() {
        return {
            loading: true,
            loadingDetail: false,
            
            loadingExport: false,

            filter: {
                company: null,
                organization: null,
                date: [null,null],
                pay_date: [null, null],
                status: null,
            },

            paging:{
                rows: 0,
                currentPage: 1,
                perPage: 10,
                total: 0,
                to: 0,
            },

            allCompany: [],
            allOrganization: [],
            dataDetail : '',
            dataTransaction: [],
            dataTransactionFiltered: [],
        }
    },
    components: {
        DatePicker
    },
    methods: {
        async onSelected(index){
            if(index !== null){
                await this.$http.get(`${this.API_URL}group/retribution/${index}`, {
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` }
                    })
                    .then(response => {
                        this.allCompany = response.data.data;
                    })
            }else{
                const company = await this.$http.get(`${this.API_URL}group/company`, 
                    {
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` 
                    }
                })
                this.allCompany = company.data.data
            }
            
        },
        convertPeriod(period) {
            if(period == 'DAILY'){
                return 'Harian'
            }else if(period == 'WEEKLY'){
                return 'Minggu'
            }else if(period == 'MONTHLY'){
                return 'Bulan'
            }else{
                return 'Tahun'
            }
        },
        loadDetail(id) {
            this.loadingDetail = true

            $('#modalDetail').modal('show')
            
            this.$http.get(`${this.API_URL}transaction/${id}`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` }
            })
            .then(response => {
                const result = response.data;
                if(result.success) {
                    this.dataDetail = result.data
                    setTimeout(() => {
                        this.loadingDetail = false;
                    }, 100);
                }else {
                    this.sAlert('error', result.message)
                    this.loadingDetail = false;
                }
            })
            .catch(error => {
                this.loadingDetail = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        refreshTransaction() {
            const id = this.dataDetail.id
            this.loadingDetail = true;

            this.$http.get(`${this.API_URL}transaction/${id}/check-payment`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` }
            })
            .then(response => {
                this.$http.get(`${this.API_URL}transaction/${id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` }
                })
                .then(response => {
                    const result = response.data;
                    if(result.success) {
                        this.dataDetail = result.data
                        setTimeout(() => {
                            this.loadingDetail = false;
                        }, 100);
                    }else {
                        this.sAlert('error', result.message)
                        this.loadingDetail = false;
                    }
                })
            })
            .catch(error => {
                this.loadingDetail = false;
                this.errorHandler(error)
            });
        },
        paginate(page){
            this.$router.push({
                name: 'groupTransaction',
                query: {
                    // keywords: null,
                    page: page,
                }
            })

            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;

            this.loadData(page)
        },
        async loadData(page) {
            this.loading = true;
            try {
                let storedData = {
                    report_type: this.$route.name == 'groupDetermination' ? 'determination' : 'transaction',
                    company_id: this.filter.company,
                    organization_id: this.filter.organization,
                    status: this.filter.status,
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                    start_pay_date: this.filter.pay_date[0] ? moment(this.filter.pay_date[0]).format('YYYY-MM-DD') : null,
                    end_pay_date: this.filter.pay_date[1] ? moment(this.filter.pay_date[1]).format('YYYY-MM-DD') : null,
                    page: page ? page : this.$route.query.page,
                }

                const transaction = await this.$http.get(`${this.API_URL}transaction`, 
                    {
                        params: storedData,
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` 
                    }
                })
                this.dataTransaction = transaction.data.data.data

                this.paging.rows = transaction.data.data.last_page
                this.paging.currentPage = transaction.data.data.current_page
                this.paging.perPage = transaction.data.data.per_page
                this.paging.total = transaction.data.data.total
                this.paging.to = transaction.data.data.to

                setTimeout(() => {
                    // this.dataTableSearch()
                }, 500);

                if(this.allCompany <= 0){
                    const company = await this.$http.get(`${this.API_URL}group/company`, 
                        {
                            headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` 
                        }
                    })
                    this.allCompany = company.data.data
                }

                if(this.allOrganization <= 0){
                    const organization = await this.$http.get(`${this.API_URL}group/organization`, 
                        {
                            headers: { 'Authorization': `Bearer ${this.$cookies.get("token_group")}` 
                        }
                    })
                    this.allOrganization = organization.data.data
                }
                
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }
        },
        async exportData(type) {
            this.loadingExport = true;
            try {
                let storedData = {
                    report_type: this.$route.name == 'groupDetermination' ? 'determination' : 'transaction',
                    company_id: this.filter.company,
                    organization_id: this.filter.organization,
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                    status: this.filter.status,
                    start_pay_date: this.filter.pay_date[0] ? moment(this.filter.pay_date[0]).format('YYYY-MM-DD') : null,
                    end_pay_date: this.filter.pay_date[1] ? moment(this.filter.pay_date[1]).format('YYYY-MM-DD') : null,
                    export: 1,
                    export_type: type
                }

                const response = await this.$http.get(`${this.API_URL}transaction`, {
                    responseType: 'blob',
                    params: storedData,
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_group")}`,
                    }
                })

                const typeData = type == 'pdf' ? '.pdf' : '.xlsx'

                fileDownload(response.data, 
                `Laporan Transaksi${this.filter.company ? '-' + this.allCompany.find(item => item.id == this.filter.company).name : ''}${this.filter.date[0] ? '-' + this.filter.date[0] : ''}${this.filter.date[1] ? '-' + this.filter.date[1] : ''}${typeData}`);
                this.loadingExport = false

            } catch (error) {
                console.log(error);
                this.loadingExport = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }
        },
        convertDate(date){
            return moment(date).format('DD MMMM YYYY')
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>